import React from 'react'

const Sales = () => {
  return (
    <div style={{
        padding:"300px 0px"
    }}>
      <h5 style={{textAlign:"center"}}>No Sales Found.</h5>
    </div>
  )
}

export default Sales
